<template>
  <div class="change-password-dialog">
    <el-dialog append-to-body :title="row ? '修改账号' : '添加账号'" :visible="isShow" :close-on-click-modal="false" @close="closeDialog" width="600px">
      <el-form v-loading="loading" class="form" :model="vForm" ref="vForm" size="medium" label-width="80px" auto-complete="off">
        <el-form-item label="昵称" class="form-group" prop="nickname" :rules="{ required: true, message: '昵称必填' }">
          <el-input type="text" class="form-control" v-model="vForm.nickname" />
        </el-form-item>
        <el-form-item label="地域权限" class="form-group" prop="area_data" :rules="{ required: true, message: '地域权限必填' }">
          <div v-for="item in regionList" :key="item.id" class="v-mb-10">
            <el-checkbox v-model="item.checked" :label="item.name" class="v-mr-10" @change="onRegionChange" />
            <div v-if="item.checked" class="region-control">
              <el-cascader
                v-model="item.area_id"
                placeholder="选择区域"
                :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', expandTrigger: 'hover' }"
                :options="item.child"
                filterable
                class="v-mr-20"
                @change="onRegionChange"
              />
              <el-radio v-model="item.user_type" :label="1" @change="onRegionChange">观察者</el-radio>
              <el-radio v-model="item.user_type" :label="2" @change="onRegionChange">运营方</el-radio>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="登录账号" class="form-group" prop="login_name" :rules="{ required: true, validator: validator.login_name_mobile }">
          <el-input type="text" class="form-control" v-model="vForm.login_name" placeholder="11位手机号码" />
        </el-form-item>
        <el-form-item label="状态" class="form-group" prop="status">
          <el-radio v-model="vForm.status" :label="1">启用</el-radio>
          <el-radio v-model="vForm.status" :label="2">禁用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import validator from '../validator';

export default {
  props: ['isShow', 'row'],

  data() {
    return {
      validator,
      validatorassword: this.row ? null : validator.password,
      doSubmitLoading: false,
      vForm: {
        nickname: '',
        id: '',
        login_name: '',
        status: 1,
        area_data: [],
      },
      loading: false,
      regionList: [],
    };
  },
  created() {
    this.getRegionList();
  },
  methods: {
    closeDialog() {
      this.$emit('update:isShow', false);
    },

    async getUserAreaInfo() {
      try {
        let res = await this.api.userAdmin.getUserAreaInfo({ user_id: this.row.id });
        this.vForm.nickname = res.data.nickname;
        this.vForm.login_name = res.data.login_name;
        this.vForm.status = res.data.status;
        this.vForm.id = res.data.id;
        res.data.area.forEach((itemSource) => {
          this.regionList.forEach((itemRegion) => {
            if (itemSource.shop_id == itemRegion.id) {
              itemRegion.checked = true;
              itemRegion.area_id = itemSource.area_data;
              itemRegion.user_type = itemSource.user_type;
            }
          });
        });
        this.onRegionChange();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    async getRegionList() {
      this.loading = true;
      try {
        let res = await this.api.regionAdmin.getAllList();
        res.data.forEach((item) => {
          item.checked = false;
          item.user_type = 1;
        });
        this.regionList = res.data;
        if (this.row) {
          this.getUserAreaInfo();
        } else {
          this.loading = false;
        }
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },

    onRegionChange() {
      this.vForm.area_data = this.regionList.filter((item) => item.checked && item.area_id).map((item) => ({ area_id: item.area_id[item.area_id.length - 1], user_type: item.user_type }));
    },

    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        let res = await this.api.userAdmin[this.row ? 'editAdminSaaS' : 'addAdminSaaS'](this.vForm);
        this.$message.success(res.message);
        this.doSubmitLoading = false;
        this.closeDialog();
        this.$emit('success', this.row ? '' : 1);
      } catch (ex) {
        console.error(ex);
        this.doSubmitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.select-box {
  position: relative;
}

.select-box-handle {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
.region-control {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
</style>
